import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/utils/cn';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, invalid, ...props }, ref) => (
    <input
      ref={ref}
      className={cn(
        'h-9 w-full rounded-md bg-white/70 px-3 text-body text-fg-primary backdrop-blur-sm',
        'border border-stroke-hairline/15 placeholder:text-fg-tertiary',
        'shadow-[inset_0_1px_2px_rgba(14,21,25,0.05)]',
        'transition-colors duration-120 ease-apple',
        'focus:border-accent/40 focus:bg-white',
        invalid && 'border-danger/60',
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = 'Input';
